import {
  GraphQlClient,
  Auth,
  Moment,
  Storage,
} from '@intelipost-js/secure-providers';

export default {
  getModulesPermissions() {
    return GraphQlClient.query(`
    query{
      user {
        permissions{
          name
          permission
        }
        security {
          token_timeout_inactivity
        }
      }
    }`)
      .then((res) => {
        const {
          data = {},
        } = res || {};
        const {
          user = {},
        } = data || {};
        const {
          security,
        } = user;

        Storage.set('session', {
          security: {
            ...security,
            session_start: Moment(),
          },
        });

        Auth.updateUser(user);

        return Promise.resolve(user);
      });
  },
  getEnvStatus({ commit }) {
    return GraphQlClient.query(`
    query{
      user {
        hide_environment
      }
    }`)
      .then((res) => {
        const {
          data = {},
        } = res || {};
        const {
          user = {},
        } = data || {};

        commit('setEnvVisibility', user.hide_environment);

        Auth.updateUser(user);

        return Promise.resolve(user);
      });
  },
};



// WEBPACK FOOTER //
// ./src/stores/permissions/actions.js